<template>
  <my-crud
    caption="Parâmetros"
    singular="Parâmetros"
    :deletable="false"
    :creatable="false"
    :showUnique="true"
  />
</template>

<script>
  export default {
    data: () => ({
      main: {
        fields: {
          id: {}, 
          certificado: {
            text: 'Certificado digital modelo A1',
            type: 'upload',
            class: 'xs12 md6'
          },
          senhaCertif: {
            text: 'Senha certificado', 
            type: 'password',
            hint: 'Altere para redefinir senha'
          }
        }
      }
    })
  }
</script>
